import transakcije from "../../../../assets/transakcije.svg";
import BaseHeading from "../../../../baseComponents/baseHeading.js";
import BaseImage from "../../../../baseComponents/baseImage";

function TransactionsLeftSide() {
  return (
    <>
      
    </>
  );
}

export default TransactionsLeftSide;
